import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import { Box, Pagination, Typography } from "@mui/material";
import {
    BundleTableBox,
    BundleTableContainerWrapper,
    DropdownWrap,
} from "./BundleGridStyled";
import { quoteHeaders } from "../CompareQuote/Data";
import ManageBundleAccordian from "./ManageBundleAccordian";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from '@mui/material/Grid';

const BundleGrid = ({
    headerCells,
    searchText,
    bundlesLoading,
    loggedUser,
    bundledQuotes,
    showNotification,
    updateBundleByIndex,
    prepareAndUpdateBundleObject,
    removeBundleFromList,
    samLeadershipData
}) => {
    const [order, setOrder] = React.useState("desc");
    const [orderBy, setOrderBy] = useState("");
    const [isDate, setIsDate] = useState(false);
    const [page, setPage] = useState(1); 
    const [rowsPerPage, setRowsPerPage] = useState(10); 


    const tableRows =
        searchText === ""
            ? [...bundledQuotes]
            : bundledQuotes.filter(
                (x) =>
                    x[0].bundleDetails.bundleName
                        ?.toLowerCase()
                        .indexOf(searchText.toLowerCase()) > -1 ||
                    x[0].bundleDetails.createdBy
                        ?.toLowerCase()
                        .indexOf(searchText.toLowerCase()) > -1 ||
                    x[0].bundleDetails.createdDate
                        ?.toLowerCase()
                        .indexOf(searchText.toLowerCase()) > -1 ||
                    x[0].bundleDetails.bundleProducts
                        ?.toLowerCase()
                        .indexOf(searchText.toLowerCase()) > -1 ||
                    x[0].bundleDetails.statusName
                        ?.toLowerCase()
                        .indexOf(searchText.toLowerCase()) > -1
            );

    
    const paginatedRows = tableRows.slice(
        (page - 1) * rowsPerPage,
        (page - 1) * rowsPerPage + rowsPerPage
    );

    useEffect(() => {
        setOrderBy("");
    }, [bundledQuotes]);

    const createSortHandler = (property, isDate) => (event) => {
        setOrder(order === "asc" ? "desc" : "asc");
        setOrderBy(property);
        setIsDate(isDate);
    };

    function getBundleAccordian() {
        return (
            <DropdownWrap>
                <ManageBundleAccordian
                    quoteHeaders={quoteHeaders}
                    bundleArrayObject={paginatedRows}
                    loggedUser={loggedUser}
                    bundleRevenue={null}
                    showNotification={showNotification}
                    searchText={searchText}
                    updateBundleByIndex={updateBundleByIndex}
                    prepareAndUpdateBundleObject={prepareAndUpdateBundleObject}
                    removeBundleFromList={removeBundleFromList}
                    samLeadershipData={samLeadershipData}
                />
            </DropdownWrap>
        );
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage); 
    };

    return (
        <Box sx={{ paddingBottom: 6, width: "100%" }}>
            <BundleTableBox>
                <BundleTableContainerWrapper component={Paper} >
                    <Box
                        className="bundleTableContainer"
                        sx={{
                            maxHeight: "60vh",
                            overflowY: "auto"
                        }}
                    >
                        {/*<Grid container spacing={2}>*/}
                        {/*    {headerCells.map((headerCell) => (*/}
                        {/*        <Grid item sm={headerCell.sm} >*/}
                        {/*            {headerCell.label}                                    */}
                        {/*        </Grid>*/}
                        {/*    ))}                            */}
                        {/*</Grid>                       */}
                        <Table stickyHeader-aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    {headerCells.map((headerCell) => (

                                        <TableCell
                                            size="small"
                                            className={
                                                headerCell.id === "statusName"
                                                    ? "fixedcolumnHeadertwo"
                                                    : "dragColumnHeader"
                                            }
                                            key={headerCell.id}
                                            align="center"
                                            sx={{
                                                textAlign: "center",
                                                whiteSpace: "nowrap",
                                                width: "auto",
                                            }}
                                        >
                                            {headerCell.label}
                                            <TableSortLabel
                                                active={orderBy === headerCell.id}
                                                direction={orderBy === headerCell.id ? order : "desc"}
                                                onClick={createSortHandler(
                                                    headerCell.id,
                                                    headerCell?.isDate
                                                )}
                                            />
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                        </Table>
                    </Box>
                    {paginatedRows.length > 0 ? (
                        getBundleAccordian()
                    ) : (
                        <TableRow className="noDataRow">
                            {!bundlesLoading && paginatedRows.length === 0 && (
                                <p className="noquotetext">
                                    Bundles are not available for the selected opportunity.
                                </p>
                            )}
                            {bundlesLoading && (
                                <>
                                        <p className="noquotetext">Fetching bundles.. Please wait<CircularProgress size="15px" /></p>
                                    
                                </>

                            )}
                        </TableRow>
                    )}
                </BundleTableContainerWrapper>

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: 1,
                    }}
                >
                    <Typography variant="body2">
                        <span
                            style={{ fontWeight: "bold", color: "#1b4a83", fontSize: 14 }}
                        >
                            {tableRows.length}
                        </span>
                        {` Total records`}
                    </Typography>
                    <Pagination
                        count={Math.ceil(tableRows.length / rowsPerPage)} 
                        page={page}
                        onChange={handleChangePage}
                        siblingCount={1}
                        boundaryCount={1} 
                        variant="text"
                    />
                </Box>
            </BundleTableBox>
        </Box>
    );
};

export default BundleGrid;
